/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Map_Filter_DisableInputs */

const fr_map_filter_disable = /** @type {(inputs: Map_Filter_DisableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Désactiver le filtre`)
};

const en_map_filter_disable = /** @type {(inputs: Map_Filter_DisableInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Disable filter`)
};

/**
* | output |
* | --- |
* | "Disable filter" |
*
* @param {Map_Filter_DisableInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const map_filter_disable = /** @type {((inputs?: Map_Filter_DisableInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Map_Filter_DisableInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_map_filter_disable(inputs)
	return en_map_filter_disable(inputs)
});